import React from 'react';
import SupplierBadge from './SupplierBadge';
import SupplierLocation from './SupplierLocation';

// Product result card for the Products mode on /search. Reuses the
// supplierCard shell so the two modes share one visual language.
function ProductCard({ name, description, price_label, moq_label, image_url, supplier }) {
  const profileUrl = supplier?.shortcode
    ? `/supplier_profiles/${supplier.shortcode}`
    : null;

  const body = (
    <>
      {image_url ? (
        <img src={image_url} alt={name} className="supplierCardLogo productCardImage" />
      ) : (
        <div className="supplierCardLogo productCardImagePlaceholder">
          <i className="ph ph-package"></i>
        </div>
      )}
      <div className="supplierCardNameContainer productCardNameContainer">
        <p className="title is-6 mb-1 supplierCardName">{name}</p>
      </div>
      <div className="supplierCardDescriptionContainer productCardDescriptionContainer">
        <p className="supplierCardDescription">{description}</p>
      </div>
      <div className="productCardPricing">
        {price_label && <span className="has-text-weight-semibold">{price_label}</span>}
        {moq_label && <span className="has-text-grey">{moq_label}</span>}
      </div>
      {supplier && (
        <div className="productCardSupplier">
          <p className="is-size-7 has-text-grey productCardSupplierName">{supplier.name}</p>
          <SupplierBadge tier={supplier.tier} />
          <SupplierLocation
            city={supplier.city}
            state={supplier.state}
            country={supplier.country}
          />
        </div>
      )}
    </>
  );

  return (
    <div className="supplierCard productCard">
      <div className="supplierCardContent">
        {profileUrl ? (
          <a
            href={profileUrl}
            className="supplierCardLink"
            target="_blank"
            rel="noopener noreferrer"
          >
            {body}
          </a>
        ) : (
          <div className="supplierCardLink">{body}</div>
        )}
      </div>
      {profileUrl && (
        <a
          href={profileUrl}
          className="button is-small is-rounded contactSupplierButton"
          target="_blank"
          rel="noopener noreferrer"
        >
          View supplier
        </a>
      )}
    </div>
  );
}

export default ProductCard;
